import { useCmsContext } from "@rotorstudios/fe-cms";
import { useQuery } from "@tanstack/react-query";

import type { iCmsDynamicVariable } from "./types";
import { CMS_DATA_SOURCES, CMS_DATASOURCES_DYNAMIC_VARIABLES } from "./static";
import { useFetchCMSData } from "./useFetchCMSData";

const CACHE_TIME = 5 * 60 * 1000; // 3 minutes in ms

const useDynamicVariables = () => {
  const { fetchData } = useFetchCMSData();
  const { siloManifest } = useCmsContext();

  const path = siloManifest?.[CMS_DATA_SOURCES]?.get(CMS_DATASOURCES_DYNAMIC_VARIABLES);

  // **********************
  // CMS Dynamic Variables Data
  // ***********************
  const getDynamicVariablesData = async (): Promise<Map<string, iCmsDynamicVariable>> => {
    if (!path)
      throw new Error("Dynamic Variables data source not found in silo manifest");

    const raw = await fetchData(path);
    const dynamicVariablesMap = new Map<string, iCmsDynamicVariable>();

    for (const variable of raw.data?.variables ?? []) {
      dynamicVariablesMap.set(variable.variableCode, variable);
    }

    return dynamicVariablesMap;
  };

  const { data: dynamicVariables } = useQuery<Map<string, iCmsDynamicVariable>>({
    queryKey: ["dynamicVariables", path],
    queryFn: () => getDynamicVariablesData(),
    enabled: Boolean(path),
    staleTime: CACHE_TIME,
  });

  return {
    dynamicVariables,
  };
};

export default useDynamicVariables;
